import { useCallback, useEffect, useState } from "react";
import { axios, errorResponse } from "../../helpers";

const useDashboardStats = (token) => {
  const [stats, setStats] = useState({
    totalSales: 0,
    todaySales: 0,
    totalCustomers: 0,
    totalProducts: 0,
    pendingTransactions: 0,
    confirmedTransactions: 0,
    canceledTransactions: 0,
    refundList: 0,
  });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchDashboardStats = useCallback(async () => {
    if (!token) {
      setIsLoading(false);
      return;
    }

    try {
      setIsLoading(true);
      const response = await axios.get("/v1/dashboard/stats", {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.data.success) {
        setStats(response.data.data);
        setError("");
      } else {
        setError(response.data.message || "Failed to fetch dashboard stats");
      }
    } catch (err) {
      const msg = errorResponse(err) || "Error fetching dashboard stats";
      setError(msg);
    } finally {
      setIsLoading(false);
    }
  }, [token]);

  useEffect(() => {
    fetchDashboardStats();
  }, [fetchDashboardStats]);

  return { stats, isLoading, error, refetch: fetchDashboardStats };
};

export default useDashboardStats;
